export const translations = {
  es: {
    // Navbar
    home: "INICIO",
    services: "SERVICIOS",
    ourWork: "NUESTRO TRABAJO",
    aboutUs: "NOSOTROS",
    contactUs: "CONTÁCTANOS",
    
    // About Us Dropdown
    aboutUs: "Nosotros",
    ourTeam: "Nuestro Equipo",
    companies: "Empresas",
    
    // Hero
    heroTitle: "Comprometidos con la Calidad, Construidos con Integridad",
    heroDescription: "Cada proyecto comienza con tu visión. Con la integridad como nuestra base y la calidad como nuestro estándar, construimos espacios diseñados para durar.",
    viewProjects: "Ver Nuestros Proyectos",
    
    // Services
    servicesTitle: "Nuestros Servicios",
    servicesSubtitle: "Apoyando a los clientes a través del proceso completo de construcción con habilidad y visión.",
  retailUnit: "Locales comerciales",
    retailDescription: "Diseñada para dar la bienvenida, construida para perdurar",
  customHome: "Casas campestres",
    customHomeDescription: "Diseñada para vivir, construida para ti",
  renovation: "Remodelaciones",
    renovationDescription: "Renovar. Redefinir. Reimaginar.",
    takeALook: "Echar un vistazo",
    contactUs: "Contáctanos",
    
    // About Us
    aboutUsTitle: "Nosotros",
    aboutUsDescription: "Conoce más sobre nuestra empresa, nuestros valores y nuestro compromiso con la excelencia en construcción y remodelación desde 2002.",
    aboutUsText: "Somos una empresa dedicada a la construcción, mantenimiento y remodelación de instalaciones físicas desde 2002. Nuestro enfoque está en satisfacer las necesidades de los sectores industrial, comercial y corporativo, brindando apoyo personalizado a lo largo de cada proyecto, desde la concepción hasta la finalización.",
    aboutUsText2: "Nuestro compromiso con la responsabilidad y profesionalismo se refleja en la calidad de nuestros diseños, procesos, materiales, soluciones integrales y servicio postventa.",
    learnMore: "Saber más",
    learnMoreText: "Conoce nuestra empresa un poco mejor; descubre quiénes somos, los clientes y socios con los que hemos trabajado, los valores que nos guían y mucho más sobre lo que nos define.",
    
    // Projects
    ourWorkTitle: "Nuestro Trabajo",
    customHomeLaCeja: "Casa Personalizada La Ceja",
    customHomeLaCejaDesc: "Una casa elaborada con cuidado, reflejando los sueños y estilo de vida de sus propietarios.",
    customHomeElRetiro: "Casa Personalizada El Retiro",
    customHomeElRetiroDesc: "Cada detalle diseñado para sentirse personal, cálido y verdaderamente vivido.",
    nespressoOffice: "Oficina Nespresso K2",
    nespressoOfficeDesc: "Transformando la visión en realidad con un espacio de trabajo que encarna la identidad de Nespresso.",
    servidCenter: "Centro de Salud Mental Servid",
    servidCenterDesc: "Diseñado para ofrecer servicios especializados de salud mental en un ambiente seguro y cómodo.",
  moreWorkCta: "Conoce más de nuestros trabajos",
  projectLocation: "Ubicación",
  projectType: "Tipo",
  projectYear: "Año",
  projectGallery: "Galería",
  carouselPrevious: "Anterior",
  carouselNext: "Siguiente",
  closeModal: "Cerrar",
    
    // Schedule Consultation
    scheduleTitle: "Programa una Consulta.",
    
    // Contact
    contactTitle: "Contáctanos",
    contactDescription: "¿Listo para comenzar tu próximo proyecto? Ponte en contacto con nosotros hoy y discutamos cómo podemos hacer realidad tu visión.",
    otherInquiries: "¿Otras Consultas?",
    otherInquiriesText: "Queremos saber de ti. Completa el formulario a continuación y nos pondremos en contacto.",
    fullName: "Nombre Completo",
    emailAddress: "Dirección de Correo",
    phoneNumber: "Número de Teléfono",
    message: "Mensaje",
    submit: "Enviar",
    
    // Companies
    companiesTitle: "Empresas con las que Hemos Trabajado",
    companiesDescription: "A lo largo de los años, Eyf Constructores ha tenido el privilegio de trabajar junto a organizaciones líderes en diversas industrias. Estas colaboraciones reflejan la confianza depositada en nosotros y la calidad que aportamos a cada proyecto.",
    ourPartners: "Nuestros Socios",
    partnersDescription: "Estamos orgullosos de haber trabajado con estas marcas y organizaciones líderes, brindando servicios excepcionales de construcción y remodelación en diversas industrias.",
    startProject: "Iniciar un Proyecto",
    
    // Our Team
    ourTeamTitle: "Nuestro Equipo",
    ourTeamDescription: "El corazón de todo lo que hacemos. Combinando experiencia técnica con creatividad y dedicación, trabajamos colaborativamente para dar vida a cada proyecto con precisión y cuidado.",
    getToKnowUs: "Conócenos",
    getToKnowUsDescription: "Nuestros diversos profesionales comparten un compromiso común con la integridad, calidad e innovación, asegurando que cada cliente reciba soluciones adaptadas a sus necesidades y aspiraciones. Juntos, no solo construimos estructuras, construimos confianza y relaciones duraderas.",
    executiveLeadership: "Liderazgo Ejecutivo",
    ourTeam: "Nuestro Equipo",
    readyToWork: "¿Listo para trabajar con nuestro equipo experimentado?",
    startYourProject: "Iniciar Tu Proyecto",
    
    // Footer
    address: "Carrera 27 # 37B sur -21, Envigado, Antioquia",
    phone: "P: (311) 334-7553",
    email: "gerencia@eyfconstructores.com",
    rightsReserved: "© 2025 Eyf Constructores | Todos los Derechos Reservados |",
    websiteDesign: "Diseño de Sitio Web por Daniela López & Victor Chavez",
    
    // WhatsApp
    whatsappTooltip: "¡Escríbenos por WhatsApp!",
    whatsappMessage: "Hola, me interesa conocer más sobre sus servicios de construcción.",
    
    // Build In Our Way
    buildInOurWayTitle: "Construimos a Nuestra Manera",
    buildInOurWayDescription: "Estamos comprometidos con la excelencia en el servicio, resultados de calidad y atención al cliente.",
    
    // Methods
    methodsTitle: "Métodos",
    preconstruction: "Preconstrucción",
    preconstructionDesc: "Planificación y detallado exitoso del proyecto",
    constructionManagement: "Gestión de Construcción",
    constructionManagementDesc: "Servicios localmente y mundialmente",
    projectManagement: "Gestión de Proyectos",
    projectManagementDesc: "Éxito de principio a fin",
    
    // Contact Us Section
    contactUsTitle: "Contáctanos",
    contactUsDescription: "¿Tienes una pregunta o quieres ponerte en contacto con un miembro del equipo de Eyf Constructores? Nos encantaría saber de ti.",
    getInTouch: "Ponte en contacto",
    
    // Our Work
    ourWorkDescription: "Explora nuestro portafolio de proyectos completados que muestran nuestro compromiso con la calidad, innovación y satisfacción del cliente.",
    customHomeBuilding: "Construcción de Casa Personalizada",
    bathroomRenovation: "Renovación de Baño",
    nespressoRetailUnit: "Unidad Retail Nespresso",
    nespressoOfficeBuilding: "Edificio de Oficinas Nespresso",
    mentalHealthCenterServid: "Centro de Salud Mental Servid",
    
    // Projects Grid
    checkOurProjects: "Revisa Nuestros Proyectos",
    loadMoreProjects: "Cargar Más Proyectos",
    
    // About Us Page
    aboutUsPageDescription: "Conoce más sobre nuestra empresa, nuestros valores y nuestro compromiso con la excelencia en construcción y remodelación desde 2002.",
    
    // Companies Page
    companiesTitle: "Empresas con las que Hemos Trabajado",
    companiesDescription: "A lo largo de los años, Eyf Constructores ha tenido el privilegio de trabajar junto a organizaciones líderes en diversas industrias. Estas colaboraciones reflejan la confianza depositada en nosotros y la calidad que aportamos a cada proyecto.",
    
    // Our Team Page
    ourTeamDescription: "El corazón de todo lo que hacemos. Combinando experiencia técnica con creatividad y dedicación, trabajamos colaborativamente para dar vida a cada proyecto con precisión y cuidado.",
    
    // Who We Are Component
    whoWeAreTitle: "Quiénes Somos",
    whoWeAreText1: "Durante años, EYF Constructores ha construido espacios e infraestructura que impulsan el progreso e inspiran confianza.",
    whoWeAreText2: "Nuestro trabajo abarca una amplia gama de mercados: desde residencial y comercial hasta corporativo y cultural, educativo y de salud, así como la infraestructura esencial que los conecta a todos.",
    whoWeAreText3: "Estamos dedicados a entregar valor para nuestros clientes y socios, creando oportunidades para nuestro equipo y contribuyendo al crecimiento de las comunidades donde vivimos y construimos.",
    yearFounded: "Año de Fundación",
    committedToQuality: "Comprometidos con la Calidad",
    satisfiedClients: "Clientes Satisfechos",
    completedProjects: "Proyectos Completados",
    
    // Companies Grid
    ourPartners: "Nuestros Socios",
    partnersDescription: "Estamos orgullosos de haber trabajado con estas marcas y organizaciones líderes, entregando servicios excepcionales de construcción y remodelación en diversas industrias.",
    interestedInWorking: "¿Interesado en trabajar con nosotros? Hablemos de tu proyecto.",
    startAProject: "Iniciar un Proyecto",
    
    // Our Team Component
    getToKnowUs: "Conócenos",
    ourTeamDescription: "Nuestros diversos profesionales comparten un compromiso común con la integridad, calidad e innovación, asegurando que cada cliente reciba soluciones adaptadas a sus necesidades y aspiraciones. Juntos, no solo construimos estructuras, construimos confianza y relaciones duraderas.",
    executiveLeadership: "Liderazgo Ejecutivo",
    ourTeam: "Nuestro Equipo",
    readyToWork: "¿Listo para trabajar con nuestro equipo experimentado?",
    startYourProject: "Inicia Tu Proyecto",
    ceoDescription: "Nuestro equipo de liderazgo aporta años de experiencia en la industria de la construcción y un compromiso compartido con la integridad y la excelencia. Guiados por esta visión, lideran a nuestro personal para entregar resultados excepcionales a clientes, socios y las comunidades a las que servimos.",
    
    // Core Values
    coreValues: "Valores Fundamentales",
    fairAndFirm: "Justo y firme",
    accountable: "Responsable",
    alwaysImproving: "Siempre mejorando",
    teamDriven: "Orientado al equipo",
    
    // Core Values Detailed
    weBuildWithPurpose: "Construimos con Propósito",
    weBuildWithPurposeDesc: "Cada proyecto refleja nuestra responsabilidad de entregar espacios que perduren e inspiren.",
    weHonorOurWord: "Honramos Nuestra Palabra",
    weHonorOurWordDesc: "La confianza es la base de nuestro trabajo. Los compromisos adquiridos son compromisos cumplidos.",
    weCareForPeople: "Nos Importan las Personas",
    weCareForPeopleDesc: "Desde nuestros clientes hasta nuestro equipo y comunidades, priorizamos el bienestar y el respeto.",
    wePushBoundaries: "Empujamos los Límites",
    wePushBoundariesDesc: "La innovación y la creatividad nos guían hacia soluciones más inteligentes y eficientes.",
    
    // Mission & Vision
    mission: "Misión",
    vision: "Visión",
    missionText: "Entregar soluciones integrales de construcción, remodelación y mantenimiento de instalaciones que combinen calidad, eficiencia y satisfacción del cliente. Superamos las expectativas abrazando la excelencia, innovación y sostenibilidad como base de cada proyecto que damos vida.",
    visionText: "Establecer el estándar en construcción a través de calidad inquebrantable, servicio personalizado y compromiso con la satisfacción del cliente. Con crecimiento internacional por delante, continuamos manteniendo nuestros valores fundamentales de integridad, profesionalismo y excelencia en cada proyecto que emprendemos.",
    
    // Our History
    ourHistory: "Nuestra Historia",
    foundation: "Fundación",
    foundationDesc: "Inicio de nuestra empresa con la visión de construir espacios de calidad.",
    nespressoPartnership: "Asociación Nespresso",
    nespressoPartnershipDesc: "Primera gran colaboración que marcó nuestro crecimiento en el mercado.",
    expansion: "Expansión",
    expansionDesc: "Crecimiento de operaciones y ampliación de servicios a nivel nacional.",
    
    // Legacy Build on Trust
    legacyBuildOnTrust: "Legado Construido en Confianza",
    legacyBuildOnTrustText: "En EYF Constructores, la confianza es la base de todo lo que construimos. Para nosotros, cada proyecto es más que ladrillos y concreto: es un legado duradero creado a través de integridad, responsabilidad y compromiso. Nuestros clientes, socios y comunidades confían en nosotros porque entregamos con transparencia, calidad y cuidado, asegurando que cada espacio que construimos refleje la confianza depositada en nuestras manos.",
    
    // Team Roles
    directorOfAdministration: "Directora de Administración",
    directorOfOperations: "Director de Operaciones",
    designer: "Diseñadora",
    accountingPartner: "Socia Contable",
    webDesignPartner: "Socio Diseño Web",
    renderingPartner: "Socio Renderizado",
    
    // Contact Us Page
    contactUsPageDescription: "¿Listo para comenzar tu próximo proyecto? Ponte en contacto con nosotros hoy y hablemos sobre cómo podemos dar vida a tu visión.",
    
    // Inquiry Categories
    employmentOpportunities: "Oportunidades de Empleo",
    employmentOpportunitiesDesc: "Si estás buscando unirte al equipo de Eyf Constructores, explora las posiciones abiertas escribiendo aquí. Si crees que podrías haber visto una publicación de trabajo fraudulenta o has recibido una solicitud de entrevista no solicitada para una posición en Eyf Constructores, por favor háznoslo saber aquí.",
    tradeContractorInterestForm: "Formulario de Interés de Contratista",
    tradeContractorInterestFormDesc: "Invitamos a las empresas a enviar su interés en trabajar con Eyf Constructores en futuras oportunidades. Para completar el formulario de interés de contratista, por favor haz clic aquí.",
    employmentVerification: "Verificación de Empleo",
    employmentVerificationDesc: "Si quieres verificar el empleo de un empleado, por favor haz clic aquí.",
    ourOffices: "Nuestras Oficinas",
    ourOfficesDesc: "Para información sobre las ubicaciones de nuestras oficinas corporativas, haz clic aquí.",
    
    // Contact Form
    otherInquiries: "¿Otras Consultas?",
    otherInquiriesDesc: "Queremos saber de ti. Completa el formulario a continuación y nos pondremos en contacto.",
    fullName: "Nombre Completo",
    fullNamePlaceholder: "Tu nombre completo",
    emailAddress: "Dirección de Email",
    emailPlaceholder: "tu@email.com",
    phoneNumber: "Número de Teléfono",
    phonePlaceholder: "+57 300 123 4567",
    message: "Mensaje",
    messagePlaceholder: "Cuéntanos sobre tu proyecto...",
    submit: "Enviar"
    ,
    // Contact form messages
    contactSendSuccess: "Mensaje enviado. Nos pondremos en contacto pronto.",
    contactSendError: "Error al enviar el mensaje. Por favor intenta nuevamente más tarde.",
    formValidationError: "Por favor corrige los errores en el formulario.",
    fullNameRequired: "El nombre es requerido",
    emailInvalid: "Por favor ingresa un correo válido",
    phoneRequired: "El número de teléfono es requerido",
    messageRequired: "El mensaje es requerido",
    sending: "Enviando..."
  },
  
  en: {
    // Navbar
    home: "HOME",
    services: "SERVICES",
    ourWork: "OUR WORK",
    aboutUs: "ABOUT US",
    contactUs: "CONTACT US",
    
    // About Us Dropdown
    aboutUs: "About Us",
    ourTeam: "Our Team",
    companies: "Companies",
    
    // Hero
    heroTitle: "Committed to Quality, Built on Integrity",
    heroDescription: "Every project begins with your vision. With integrity as our foundation and quality as our standard, we build spaces designed to last.",
    viewProjects: "View Our Projects",
    
    // Services
    servicesTitle: "Our Services",
    servicesSubtitle: "Supporting clients through the full construction process with skill and insight.",
    retailUnit: "Retail Unit",
    retailDescription: "Crafted to Welcome, Built to Endure",
    customHome: "Custom Home Building",
    customHomeDescription: "Designed for Living, Built for You",
    renovation: "Renovation",
    renovationDescription: "Renew. Redefine. Reimagine.",
    takeALook: "Take a look",
    contactUs: "Contact Us",
    
    // About Us
    aboutUsTitle: "About Us",
    aboutUsDescription: "Learn more about our company, our values, and our commitment to excellence in construction and remodeling since 2002.",
    aboutUsText: "We are a company dedicated to the construction, maintenance, and remodeling of physical facilities since 2002. Our focus is on meeting the needs of the industrial, commercial, and corporate sectors, providing personalized support throughout each project—from conception to completion.",
    aboutUsText2: "Our commitment to responsibility and professionalism is reflected in the quality of our designs, processes, materials, comprehensive solutions, and after-sales service.",
    learnMore: "Learn more",
    learnMoreText: "Get to know our company a little better; discover who we are, the clients and partners we've worked with, the values that guide us, and much more about what defines us.",
    
    // Projects
    ourWorkTitle: "Our Work",
    customHomeLaCeja: "Custom Home La Ceja",
    customHomeLaCejaDesc: "A home crafted with care, reflecting the dreams and lifestyle of its owners.",
    customHomeElRetiro: "Custom Home El Retiro",
    customHomeElRetiroDesc: "Every detail designed to feel personal, warm, and truly lived in.",
    nespressoOffice: "Nespresso Office K2",
    nespressoOfficeDesc: "Transforming vision into reality with a workspace that embodies Nespresso's identity.",
    servidCenter: "Mental Health Center Servid",
    servidCenterDesc: "Designed to offer specialized mental health services in a safe and comfortable environment.",
  moreWorkCta: "Discover more of our work",
  projectLocation: "Location",
  projectType: "Type",
  projectYear: "Year",
  projectGallery: "Gallery",
  carouselPrevious: "Previous",
  carouselNext: "Next",
  closeModal: "Close",
    
    // Schedule Consultation
    scheduleTitle: "Schedule a Consultation.",
    
    // Contact
    contactTitle: "Contact Us",
    contactDescription: "Ready to start your next project? Get in touch with us today and let's discuss how we can bring your vision to life.",
    otherInquiries: "Other Inquiries?",
    otherInquiriesText: "We want to hear from you. Fill out the form below, and we'll be in touch.",
    fullName: "Full Name",
    emailAddress: "Email Address",
    phoneNumber: "Phone Number",
    message: "Message",
    submit: "Submit",
    
    // Companies
    companiesTitle: "Companies We've Worked with",
    companiesDescription: "Over the years, Eyf Constructores has had the privilege of working alongside leading organizations across diverse industries. These collaborations reflect the trust placed in us and the quality we bring to every project.",
    ourPartners: "Our Partners",
    partnersDescription: "We're proud to have worked with these leading brands and organizations, delivering exceptional construction and remodeling services across diverse industries.",
    startProject: "Start a Project",
    
    // Our Team
    ourTeamTitle: "Our Team",
    ourTeamDescription: "The heart of everything we do. Combining technical expertise with creativity and dedication, we work collaboratively to bring each project to life with precision and care.",
    getToKnowUs: "Get to know us",
    getToKnowUsDescription: "Our diverse professionals share a common commitment to integrity, quality, and innovation, ensuring that every client receives solutions tailored to their needs and aspirations. Together, we don't just build structures, we build trust and lasting relationships.",
    executiveLeadership: "Executive Leadership",
    ourTeam: "Our Team",
    readyToWork: "Ready to work with our experienced team?",
    startYourProject: "Start Your Project",
    
    // Footer
    address: "Carrera 27 # 37B sur -21, Envigado, Antioquia",
    phone: "P: (311) 334-7553",
    email: "gerencia@eyfconstructores.com",
    rightsReserved: "© 2025 Eyf Constructores | All Rights Reserved |",
    websiteDesign: "Website Design by Daniela López & Victor Chavez",
    
    // WhatsApp
    whatsappTooltip: "Write to us on WhatsApp!",
    whatsappMessage: "Hello, I'm interested in learning more about your construction services.",
    
    // Build In Our Way
    buildInOurWayTitle: "Build in Our Way",
    buildInOurWayDescription: "We're committed to excellence in service, quality outcomes, and customer care.",
    
    // Methods
    methodsTitle: "Methods",
    preconstruction: "Preconstruction",
    preconstructionDesc: "Successful project planning and detailing",
    constructionManagement: "Construction Management",
    constructionManagementDesc: "Services locally and worldwide",
    projectManagement: "Project Management",
    projectManagementDesc: "Success from start to finish",
    
    // Contact Us Section
    contactUsTitle: "Contact Us",
    contactUsDescription: "Have a question, or want to get in touch with a member of the Eyf Constructores team? We'd love to hear from you.",
    getInTouch: "Get in touch",
    
    // Our Work
    ourWorkDescription: "Explore our portfolio of completed projects that showcase our commitment to quality, innovation, and client satisfaction.",
    customHomeBuilding: "Custom Home Building",
    bathroomRenovation: "Bathroom Renovation",
    nespressoRetailUnit: "Nespresso Retail Unit",
    nespressoOfficeBuilding: "Nespresso Office Building",
    mentalHealthCenterServid: "Mental Health Center Servid",
    
    // Projects Grid
    checkOurProjects: "Check our Projects",
    loadMoreProjects: "Load More Projects",
    
    // About Us Page
    aboutUsPageDescription: "Learn more about our company, our values, and our commitment to excellence in construction and remodeling since 2002.",
    
    // Companies Page
    companiesTitle: "Companies We've Worked with",
    companiesDescription: "Over the years, Eyf Constructores has had the privilege of working alongside leading organizations across diverse industries. These collaborations reflect the trust placed in us and the quality we bring to every project.",
    
    // Our Team Page
    ourTeamDescription: "The heart of everything we do. Combining technical expertise with creativity and dedication, we work collaboratively to bring each project to life with precision and care.",
    
    // Who We Are Component
    whoWeAreTitle: "Who We Are",
    whoWeAreText1: "For years, EYF Constructores has built spaces and infrastructure that drive progress and inspire trust.",
    whoWeAreText2: "Our work embraces a wide range of markets – from residential and commercial to corporate and cultural, educational and healthcare, as well as the essential infrastructure that connects them all.",
    whoWeAreText3: "We are dedicated to delivering value for our clients and partners, creating opportunities for our team, and contributing to the growth of the communities where we live and build.",
    yearFounded: "Year Founded",
    committedToQuality: "Committed to Quality",
    satisfiedClients: "Satisfied Clients",
    completedProjects: "Completed Projects",
    
    // Companies Grid
    ourPartners: "Our Partners",
    partnersDescription: "We're proud to have worked with these leading brands and organizations, delivering exceptional construction and remodeling services across diverse industries.",
    interestedInWorking: "Interested in working with us? Let's discuss your project.",
    startAProject: "Start a Project",
    
    // Our Team Component
    getToKnowUs: "Get to know us",
    ourTeamDescription: "Our diverse professionals share a common commitment to integrity, quality, and innovation, ensuring that every client receives solutions tailored to their needs and aspirations. Together, we don't just build structures, we build trust and lasting relationships.",
    executiveLeadership: "Executive Leadership",
    ourTeam: "Our Team",
    readyToWork: "Ready to work with our experienced team?",
    startYourProject: "Start Your Project",
    ceoDescription: "Our leadership team brings years of experience in the construction industry and a shared commitment to integrity and excellence. Guided by this vision, they lead our people to deliver outstanding results for clients, partners, and the communities we serve.",
    
    // Core Values
    coreValues: "Core Values",
    fairAndFirm: "Fair & firm",
    accountable: "Accountable",
    alwaysImproving: "Always improving",
    teamDriven: "Team-driven",
    
    // Core Values Detailed
    weBuildWithPurpose: "We Build With Purpose",
    weBuildWithPurposeDesc: "Every project reflects our responsibility to deliver spaces that last and inspire.",
    weHonorOurWord: "We Honor Our Word",
    weHonorOurWordDesc: "Trust is the foundation of our work commitments made are commitments kept.",
    weCareForPeople: "We Care For People",
    weCareForPeopleDesc: "From our clients to our team and communities, we prioritize well-being and respect.",
    wePushBoundaries: "We Push Boundaries",
    wePushBoundariesDesc: "Innovation and creativity guide us to smarter, more efficient solutions.",
    
    // Mission & Vision
    mission: "Mission",
    vision: "Vision",
    missionText: "Deliver comprehensive construction, remodeling, and facility maintenance solutions that combine quality, efficiency, and client satisfaction. We go beyond expectations by embracing excellence, innovation, and sustainability as the foundation of every project we bring to life.",
    visionText: "Set the standard in construction through uncompromising quality, personalized service, and a commitment to client satisfaction. With international growth ahead, we continue to uphold our core values of integrity, professionalism, and excellence in every project we undertake.",
    
    // Our History
    ourHistory: "Our History",
    foundation: "Foundation",
    foundationDesc: "Beginning of our company with the vision to build quality spaces.",
    nespressoPartnership: "Nespresso Partnership",
    nespressoPartnershipDesc: "First major collaboration that marked our growth in the market.",
    expansion: "Expansion",
    expansionDesc: "Growth of operations and expansion of services nationwide.",
    
    // Legacy Build on Trust
    legacyBuildOnTrust: "Legacy Build on Trust",
    legacyBuildOnTrustText: "At EYF Constructores, trust is the foundation of everything we build. For us, each project is more than bricks and concrete — it is a lasting legacy created through integrity, responsibility, and commitment. Our clients, partners, and communities rely on us because we deliver with transparency, quality, and care, ensuring that every space we construct reflects the confidence placed in our hands.",
    
    // Team Roles
    directorOfAdministration: "Director of Administration",
    directorOfOperations: "Director of Operations",
    designer: "Designer",
    accountingPartner: "Accounting Partner",
    webDesignPartner: "Web Design Partner",
    renderingPartner: "Rendering Partner",
    
    // Contact Us Page
    contactUsPageDescription: "Ready to start your next project? Get in touch with us today and let's discuss how we can bring your vision to life.",
    
    // Inquiry Categories
    employmentOpportunities: "Employment Opportunities",
    employmentOpportunitiesDesc: "If you're looking to join the Eyf Constructores team, explore open positions by writing here! If you think you might have seen a fraudulent job posting or have received an unsolicited interview request for a position at Eyf Constructores, please click let us know here.",
    tradeContractorInterestForm: "Trade Contractor Interest Form",
    tradeContractorInterestFormDesc: "We invite firms to submit their interest in working with Eyf constructores on future opportunities. To fill out the trade contractor interest form, please click here.",
    employmentVerification: "Employment Verification",
    employmentVerificationDesc: "If you want to verify employment for an employee, please click here.",
    ourOffices: "Our Offices",
    ourOfficesDesc: "For information about our corporate office locations, click here.",
    
    // Contact Form
    otherInquiries: "Other Inquiries?",
    otherInquiriesDesc: "We want to hear from you. Fill out the form below, and we'll be in touch.",
    fullName: "Full Name",
    fullNamePlaceholder: "Your full name",
    emailAddress: "Email Address",
    emailPlaceholder: "your@email.com",
    phoneNumber: "Phone Number",
    phonePlaceholder: "+1 555 123 4567",
    message: "Message",
    messagePlaceholder: "Tell us about your project...",
    submit: "Submit"
  }
};
